import { render, staticRenderFns } from "./passwordMain.vue?vue&type=template&id=62d4ef10&scoped=true&"
import script from "./passwordMain.vue?vue&type=script&lang=js&"
export * from "./passwordMain.vue?vue&type=script&lang=js&"
import style0 from "./passwordMain.vue?vue&type=style&index=0&lang=css&"
import style1 from "./passwordMain.vue?vue&type=style&index=1&id=62d4ef10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d4ef10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFlex,VLayout,VTextField})
